import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useAccount } from 'wagmi';
import { backendApiUrlBase } from '../../constants/global';
import ManageBtn from '../../component/manageBtn';
import ConnectBtn from '../../component/ConnectBtn';
import ClaimBtn from '../../component/ClaimBtn';
import coins from '../../assets/images/manageImage.png'

interface VaultItem {
  _id: string;
  symbol: string
  displayName: string;
  strategyType: string;
  name: string;
  masterChef: string | null;
  vaultAddress: string;
  apr: {
    apr: number;
  } | null;

}

function Manage() {
  const { isConnected } = useAccount();
  const [vaults, setVaults] = useState<VaultItem[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsDataLoading(true);
        const response = await fetch(`${backendApiUrlBase}vaults`);
        const data = await response.json();
        const filteredVaults = data.filter((vault: VaultItem) => vault.masterChef === "0xC7c74fB5aa1b11d2e960B6cf9C057F67c8C602bc");
        setVaults(filteredVaults);
        setIsDataLoading(false);
      } catch (error) {
        setIsDataLoading(false);
        console.error('Error fetching data:', error);
      }
    };
    if (isConnected) {
      fetchData();
    }
  }, [isConnected]);

  const representativeBodyTemplate = (rowData: VaultItem) => {
    const [part1, part2] = rowData.displayName.split('-');

    const img1 = `../image/assets/${part1.toLowerCase()}.png`;
    const img2 = `../image/assets/${part2.toLowerCase()}.png`;

    return (

      <div className='justify-content-between d-flex align-items-start whitespace-nowrap'>
        <div className='d-flex align-items-start im_dark_lightText'>
          <div className='d-flex'>
            <img src={img1} alt='img1' className='btc_asst_img_width' />
            <img src={img2} alt='img2' className='btc_img_width' />
          </div>
          <div>
            <div className='vault_header_font_size'>{rowData.displayName}</div>
            <div className='card_snd_clr fnt_14 notMobileDevice imLight'>{rowData.strategyType}</div>
          </div>
        </div>
      </div>
    );
  };

  const representativeBodyTemplateAPR = (rowData: VaultItem) => {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <span className='redHatFont fnt_wgt_600'>{rowData.symbol}</span>
      </div>
    );
  };
  const representativeBodyTemplateMaster = (rowData: VaultItem) => {
    return (
      <div className='d-flex align-items-center justify-content-center'>
        <span className='redHatFont fnt_wgt_600'>{rowData.symbol}</span>
      </div>
    );
  };

  return (
    <div className='custom-container'>
      {isConnected ? (
        <div className='second_section_xRiv outer_section_first_xRiv'>
          <div className='dsp_cont_first_section'>
            <div className='wdth_40_first'>
              <div className='holding_header_inner mt-2 stakeText redHatFont'>Stake Yield Tokens to earn $TLOS </div>
              <div className='manage-earn-claimSection margTop align-items-center'>
                <div className='mb-3'>
                  <div className='fnt_600 whitespace-nowrap'>Total Earnings</div>
                  <div className='holding_header_inner secondary_color redHatFont fnt_900'>
                  </div>
                </div>
                <div className='dsp_around mb-2'>
                  <ClaimBtn />
                </div>
              </div>
            </div>
            <div>
              <img height={200} src={coins} alt='rocket img' className='manageImage notMobileDevice' />
            </div>
          </div>
        </div>
      ) : (

        <div className='second_section_xRiv outer_section_first_xRiv'>
          <div className='dsp_cont_first_section'>
            <div className='wdth_40_first'>
              <div className='holding_header_inner mb-2 stakeText redHatFont'>Stake Yield Tokens to earn $TLOS </div>
              <div className=' manage-earn-claimSection align-items-center'>
                <div className='mb-3 '>
                  <div className='fnt_800 whitespace-nowrap'>Total Earnings</div>
                  <div className='holding_header_inner secondary_color redHatFont'>
                  </div>
                </div>
                <div className='dsp_around mb-2'>
                  <ConnectBtn />
                </div>

              </div>
            </div>
            <div>
              <img height={200} src={coins} alt='rocket img' className='manageImage notMobileDevice' />
            </div>
          </div>
        </div>
      )}
      <h2 className='redHatFont history_txt1 mt-1 ml-105'>Active Vaults</h2>
      <div className='custom-container border2 mrg_all'>
        <DataTable
          scrollable
          // scrollHeight="400px"
          tableStyle={{ minWidth: '50rem' }}
          className="p-datatable-striped"
          value={vaults}
        >
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText '
            body={representativeBodyTemplate}
            header="Vault"
          />
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray whitespace-nowrap'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText whitespace-nowrap'
            body={representativeBodyTemplateAPR}
            header="APR"
          />
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray whitespace-nowrap'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText '
            body={representativeBodyTemplateMaster}
            header="Total Staked"
          />
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray whitespace-nowrap'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText whitespace-nowrap'
            body={representativeBodyTemplateMaster}
            header="My Balance"
          />
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray whitespace-nowrap'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText whitespace-nowrap '
            body={representativeBodyTemplateMaster}
            header="My Stake"
          />
          <Column
            style={{ width: "100px" }}
            headerClassName='im_header txt_gray whitespace-nowrap'
            className='im_dark_lightBG'
            bodyClassName='im_dark_lightText whitespace-nowrap'
            body={representativeBodyTemplateMaster}
            header="Earnings"
          />
          <Column
            headerClassName='im_header txt_gray '
            className='im_dark_lightBG'
            bodyClassName='im_header txt_gray '
            style={{ width: "120px" }}
            alignFrozen="right"
            frozen
            body={(rowData: VaultItem) => (
              <span className='secondary_color crsr_pntr fnt_wgt_600 whitespace-nowrap'>Claim </span>
            )}
            header=""
          />
          <Column
            headerClassName='im_header txt_gray'
            className='im_header txt_gray'
            bodyClassName=' im_header txt_gray'
            style={{ width: "120px" }}
            alignFrozen="right"
            frozen
            body={(rowData: VaultItem) => (
              <ManageBtn
                vaultName={rowData.displayName}
                symbol={rowData.symbol}
                Img1={`../image/assets/${rowData.displayName.toLowerCase().split('-')[0]}.png`}
                Img2={`../image/assets/${rowData.displayName.toLowerCase().split('-')[1]}.png`}
                addressNew={rowData.vaultAddress}
              />
            )}
            header="Manage"
          />
        </DataTable>
      </div>
    </div>
  );
}
export default Manage;
